
import {
  computed, defineComponent, onMounted, onUnmounted, ref,
} from 'vue';
/* eslint-disable import/no-cycle */
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';
import AppLoader from '@/components/UI/AppLoader.vue';
import SpacesGroupDesc from '@/modules/spaces/components/SpacesGroupDesc.vue';

export default defineComponent({
  components: {
    AppLoader,
    SpacesGroupDesc,
  },
  setup() {
    const spacesStore = useSpacesStore();
    const dataRequest = ref(true);
    const shortList = computed(() => spacesStore.groupsByOwnerId.slice(0, 2));
    onMounted(() => {
      Promise.all([
        spacesStore.fetchUserParticipatedGroups(),
      ]).finally(() => { dataRequest.value = false; });
    });

    onUnmounted(() => {
      spacesStore.search = '';
    });
    return {
      dataRequest,
      shortList,
      spacesStore,
    };
  },
});
